import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-739433a2")

_pushScopeId("data-v-739433a2")
const _hoisted_1 = { class: "uk-navbar-left" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "navbar__version" }, "LIBRARIES", -1)
const _hoisted_3 = {
  key: 0,
  class: "uk-navbar-right navbar-right--public"
}
const _hoisted_4 = { class: "uk-navbar-right navbar-right--collapsed" }
const _hoisted_5 = {
  key: 0,
  class: "avatar body-4 uk-inline"
}
const _hoisted_6 = { class: "uk-text-center" }
const _hoisted_7 = {
  key: 0,
  class: "navbar__dropdown__link heading-2"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Open Thoth ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ThothButton = _resolveComponent("ThothButton")

  return (_openBlock(), _createBlock("header", null, [
    _createVNode("div", {
      class: `navbar--public uk-navbar ${_ctx.navIsOpen ? 'navbar--inverse' : ''}`,
      "uk-navbar": ""
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withId(() => [
            _createVNode("img", {
              src: _ctx.navIsOpen ? _ctx.icons.logoWhite : _ctx.icons.logo,
              alt: "thoth__logo"
            }, null, 8, ["src"])
          ]),
          _: 1
        }),
        _hoisted_2
      ]),
      (!_ctx.loggedIn)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_ThothButton, {
              text: "BACK TO THOTH",
              colour: _ctx.ButtonColour.Brand,
              emphasis: _ctx.ButtonEmphasis.Contained,
              size: _ctx.ButtonSize.M,
              onClick: _ctx.goToThoth
            }, null, 8, ["colour", "emphasis", "size", "onClick"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        (_ctx.loggedIn && _ctx.loaded && !_ctx.navIsOpen)
          ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.user.email.slice(0, 2)), 1))
          : _createCommentVNode("", true),
        _createVNode("img", {
          src: _ctx.navIsOpen ? _ctx.icons.cross : _ctx.icons.navbarDrop,
          alt: "navbar__selector__icon"
        }, null, 8, ["src"])
      ]),
      _createVNode("div", {
        "uk-dropdown": "mode: click; duration: 1;",
        onShow: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navIsOpen = true)),
        onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navIsOpen = false))
      }, [
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.loggedIn ? _ctx.links : _ctx.allLinks, (link) => {
            return (_openBlock(), _createBlock("div", {
              key: link.text,
              class: "navbar__dropdown__link heading-2"
            }, [
              _createVNode("a", {
                href: link.link
              }, _toDisplayString(link.text), 9, ["href"])
            ]))
          }), 128)),
          (_ctx.loggedIn)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/create",
                  class: "uk-flex uk-flex-center uk-flex-middle"
                }, {
                  default: _withId(() => [
                    _hoisted_8,
                    _createVNode("img", {
                      src: _ctx.icons.arrow,
                      alt: "arrow__icon"
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ], 32)
    ], 2)
  ]))
})